import { Box, Button, Stack, Typography, useTheme } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Loader } from "lib/@components/Loader"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { MacroExpander } from "authoring/routes/macro/components/macro-expander"
import Iconify from "minimals-template/components/Iconify"

export function DisplayJustification({ showReasonDialog, showEdit = true }) {
    const theme = useTheme()
    const { createdDate, createdBy, latestReason, loading, setIsEdit } = useBoundContext()
    if (!latestReason && loading) {
        return <Loader color="primary" />
    }

    if (!latestReason) return null

    return (
        <Stack
            backgroundColor={theme.palette.grey[200]}
            spacing={1}
            sx={{ borderRadius: 1 }}
            p={1}
            mt={3}
            data-cy="edit-schedule-reason"
        >
            <Stack
                direction="row"
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                        alignItems: "center",
                    }}
                >
                    <Iconify icon="basil:comment-solid" sx={{ color: "primary.main", width: "20px", height: "20px" }} />
                    <Typography variant="subtitle2">Justification</Typography>
                </Stack>
                {showEdit && (
                    <Button onClick={handleClick} aria-label="edit reason" data-cy="edit-reason-button">
                        <Iconify icon="mdi:pencil" sx={{ color: "primary.main", width: "16px", height: "16px" }} />
                    </Button>
                )}
            </Stack>
            <MacroExpander plainText>
                <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word", pr: 1 }}>{latestReason}</Typography>
            </MacroExpander>
            <Box display="flex" alignItems="center" sx={{ width: "100%" }}>
                <Box sx={{ flex: 1, maxWidth: "fit-content" }}>
                    <TruncatedTypography variant={"caption"} sx={{ color: "text.secondary", maxWidth: "fit-content" }}>
                        {createdBy}
                    </TruncatedTypography>
                </Box>
                <TruncatedTypography data-cy="justification-date" variant={"caption"} sx={{ color: "text.secondary" }}>
                    , {createdDate}
                </TruncatedTypography>
            </Box>
        </Stack>
    )

    function handleClick() {
        setIsEdit(true)
        showReasonDialog()
    }
}
